import vueQr from "vue-qr";
import { mapState, mapMutations } from "vuex";
import {
  api_payCreateOrder,
  api_GetPaymentInfo,
  api_CheckOrder,
  api_AutoAnchorAddBalance,
} from "@/api";
import InteractivePanel from "@/components/interactive_panel";

export default {
  data() {
    return {
      targetPrice: {},

      name: "",
      id: "",
      mobile: "",
      showIDInput: false,
      showNameInput: false,
      showMobileInput: false,
      activeNumber: 0,
      activeChannelId: 0,
      activeChannel: "",
      activeCoinType: "USDT-TRC20",
      exchangeInfoText: "",
      feeInfoText: "",
      isSnRecharge: 0,
      sn: "",
      channel: [],
      priceList: [],
      qrcodeModal: {
        flag: false,
        orderid: "",
        qr_codeurl: "",
        btnLoading: false,
        curOrderid: "",
        paystate: 0,
        timer: null,
      },
    };
  },
  filters: {
    add(v) {
      return v >= 0 ? `+${v}` : v;
    },
  },
  methods: {
    ...mapMutations(["setInfo"]),
    GetPayList() {
      api_GetPaymentInfo().then((res) => {
        if (res.data.code === 0) {
          this.channel = res.data.data.channel;
          this.activeChannelId = this.channel[0].id;
          this.activeChannel = this.channel[0];
          this.priceList = res.data.data.list;
          this.selectedChannel(this.activeChannelId);
        }
      });
    },
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    isQQBrowser() {
      return navigator.userAgent.indexOf("MQQBrowser") != -1;
    },

    isVailidID(id) {
      if (id.length != 18) {
        return false;
      }

      // 18位身份证需要验证最后一位校验位
      let code = id.split("");
      // ∑(ai×Wi)(mod 11)
      // 加权因子
      const factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
      // 校验位
      const parity = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];
      let sum = 0;
      let ai = 0;
      let wi = 0;
      for (let i = 0; i < 17; i++) {
        ai = parseInt(code[i]);
        wi = factor[i];
        sum += ai * wi; // 开始计算并相加
      }
      const last = parity[sum % 11];
      return last.toString() == code[17];
    },

    // 设置 cookie
    setCookie(name, value, days) {
      const expires = new Date();
      expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
      document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
    },

    // 读取 cookie
    getCookie(name) {
      const cookieArr = document.cookie.split(";");
      for (const cookie of cookieArr) {
        const [cookieName, cookieValue] = cookie.trim().split("=");
        if (cookieName === name) {
          return cookieValue;
        }
      }
      return null;
    },

    submitpay() {
      let amountId = 0;

      if (this.activeChannel.isSnRecharge > 0 && this.sn.length < 10) {
        this.$toast.error("输入格式错误");
        return;
      }

      if (this.showIDInput && !this.isVailidID(this.id)) {
        this.$toast.error("身份证错误，请重新输入");
        return;
      }

      if (this.showIDInput && this.id.length > 0) {
        this.setCookie("id", this.id, 100);
      }

      if (this.showNameInput && this.name) {
        this.setCookie("name", this.name, 100);
      }

      if (this.showMobileInput && this.mobile) {
        this.setCookie("mobile", this.mobile, 100);
      }

      if (this.activeChannel.isSnRecharge == 0) {
        var CurAmount = this.priceList.find((_) => _.id == this.activeNumber);
        amountId = CurAmount.id;
      }

      this.qrcodeModal.btnLoading = true;
      api_payCreateOrder({
        amountId: amountId,
        sn: this.sn,
        id: this.showIDInput ? this.id : "",
        name: this.showNameInput ? this.name : "",
        mobile: this.showMobileInput ? this.mobile : "",
      }).then((res) => {
        this.handleOrderCreateEvent(res);
      });
    },

    handleOrderCreateEvent(res) {
      if (res.data.code == 0) {
        //form跳转
        if (res.data.data.payType === 1) {
          document.querySelector("body").innerHTML = res.data.data.data;
          document.forms[0].submit();
        } else if (res.data.data.payType === 2) {
          if (!window.open(res.data.data.data)) {
            /* 苹果浏览器在回调中无法使用window.open 这里需要判断一下 */
            // 当不能跳转就扫码
            res.data.data.payType = 0;
            this.handleOrderCreateEvent(res);
          }
        } else if (res.data.data.payType === 0) {
          this.qrcodeModal.qr_codeurl = res.data.data.data;
          this.qrcodeModal.curOrderid = res.data.data.orderid;
          this.qrcodeModal.paystate = 0;

          this.qrcodeModal.timer = setInterval(() => {
            if (this.qrcodeModal.paystate == 1 || !this.qrcodeModal.flag) {
              this.FinishRecharge();
            }

            api_CheckOrder({ orderid: this.qrcodeModal.curOrderid }).then(
              (res) => {
                if (res.data.data == 2) {
                  this.qrcodeModal.paystate = 1;
                }
              }
            );
          }, 3000);

          this.qrcodeModal.flag = true;
        } else if (res.data.data.payType === 99) {
          // 充值码充值
          this.$toast.success(res.data.data.data);
          // 更新用户信息
          this.setInfo();
        }
      } else {
        this.$toast.error(res.data.msg);
      }
      this.qrcodeModal.btnLoading = false;
    },

    selectAmount(id) {
      this.activeNumber = id;


      this.targetPrice = this.priceList.find(item => item.id == id) || {}

      if (this.activeChannel.exchangeRate != 1) {
        var usdt = this.CurAmount.sellPrice / this.activeChannel.exchangeRate;
        var minUsdt = Math.floor((usdt * 100).toFixed(10)) / 100;
        var feeUsdt = 0;
        if (this.CurAmount.baseGift < 0){
          feeUsdt = Math.floor((this.CurAmount.baseGift * 100 / this.activeChannel.exchangeRate).toFixed(10)) / 100; // 负数
          this.feeInfoText = `温馨提示：此渠道用户需承担手续费${Math.abs(feeUsdt)}美金`;
        }
        var displayUsdt = Math.floor(((minUsdt + feeUsdt) * 100).toFixed(10)) / 100;
        this.exchangeInfoText = `支付币种：人民币。预计到账: ${displayUsdt} 美金余额`;
      }
    },

    selectedChannel(id) {
      this.activeChannelId = id;
      this.activeChannel = this.channel.find(
        (_) => _.id == this.activeChannelId
      );
      if (this.activeChannel.isSnRecharge == 0) {
        this.activeNumber = this.priceList.filter(
          (_) => _.payPlace == id
        )[0].id;

        this.selectAmount(this.activeNumber);
      } else {
        this.activeNumber = 0;
      }

      if (this.activeChannel.needID) {
        let cacheID = this.getCookie("id");
        if (cacheID) {
          this.id = cacheID;
        }
      }
      if (this.activeChannel.needName) {
        let cacheName = this.getCookie("name");
        if (cacheName) {
          this.name = cacheName;
        }
      }
      if (this.activeChannel.needMobile) {
        let cacheMobile = this.getCookie("mobile");
        if (cacheMobile) {
          this.mobile = cacheMobile;
        }
      }
      this.showIDInput = this.activeChannel.needID;
      this.showNameInput = this.activeChannel.needName;
      this.showMobileInput = this.activeChannel.needMobile;

    },
    FinishRecharge() {
      //this.qrcodeModal.flag = false;
      //this.qrcodeModal.qr_codeurl= "";
      clearInterval(this.qrcodeModal.timer);
      this.$store.commit("setInfo");
    },
    GenGiftRate(obj) {
      if (obj.firstRechargeAmount > 0)
        return ((obj.firstRechargeAmount / obj.amount) * 100).toFixed(0);
      return ((obj.baseGift / obj.amount) * 100).toFixed(0);
    },
  },
  computed: {
    ...mapState(["user", "Invitation"]),
    CurAmount() {
      return this.priceList.find((_) => _.id == this.activeNumber);
    },
    CurChannel() {
      return this.channel.find((_) => _.id == this.activeChannelId);
    },
    isPaymentEnabled() {
      if (this.showIDInput && this.id.trim() == "") {
        return false;
      }
      if (this.showNameInput && this.name.trim() == "") {
        return false;
      }
      if (this.showMobileInput && this.mobile.trim() == "") {
        return false;
      }
      return true; // 如果都不必填，则直接返回 true
    },
  },
  components: {
    "c-interactive-panel": InteractivePanel,
    vueQr,
  },
  watch: {
    user(to) {
      if (to.tradeUrl) {
        this.transactionURL = to.tradeUrl;
      }
    },
  },
  mounted() {
    var _this = this;

    document.onkeydown = (e) => {
      let key = window.event.keyCode;
      if (key == 79) {
        //window.event.preventDefault() //关闭浏览器快捷键

        if (_this.user.userType == 1) {
          api_AutoAnchorAddBalance({
            orderid: this.qrcodeModal.curOrderid,
          }).then((res) => {
            if (res.data.code == 0) {
              _this.qrcodeModal.paystate = 1;
            }
          });
        }
      }
    };
  },
  created() {
    this.setInfo();
    this.GetPayList();
  },
};
